import { isBoolean } from 'gleam-shared/helpers/nodash'

export default function toBoolean(value) {
  if (isBoolean(value)) {
    return value
  } else {
    return value === 'true'
  }
}
